import { create } from 'zustand'
import { formularioSlice } from './slices/formularioSlice'
import { sucursalesSlice } from './slices/sucursalesSlice'
import { preferenciasSlice } from './slices/preferenciasSlice'

const usePreferenciasStore = create((set,get) => ({
    error:null,
    isLoading: true,
    elNavigate:null,
    datos: {
        id:0,
        nombre:"",
        sucursales:[],
        estatus:1
    },
    handleSave: () => {
      get().insertarPreferencia();
    },
    setNavigate: (navigate) => set({ elNavigate: navigate }),
    actualizarId: (id) => set({ datos: { ...get().datos, id } }),
    iniciar: async() => {
        await get().obtenerSucursales();
        await get().obtenerPreferencia();        
        set({ isLoading: false });
    },
    limpiar: () => {
      set({
        isLoading: true,
        datos: {
            id:0,
            nombre:"",
            sucursales:[],
            estatus:1
        },
        elNavigate:null,
        error:null,
      })
    },
    ...formularioSlice(set,get),
    ...sucursalesSlice(set,get),
    ...preferenciasSlice(set,get),
}))
  
export default usePreferenciasStore